

const initialState = {
  changePasswordDetailError: {
    oldPasswordErr: {},
    newPasswordErr: {},
    confirmPasswordErr: {},
  }
};

const changePasswordErrorReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'CHANGEPASSWORDERROR': 
      if (!action.payload) {
        return initialState;
      } else {
        return {
          ...state,
          changePasswordDetailError: action.payload
        };
      }
    default:
      return state;
  }
};

export default changePasswordErrorReducer;